import { Component, Inject, OnDestroy, OnInit, Input } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Profile } from '../../models/profile';
import { Status } from '../../models/user-profile';
import { CvMapComponent } from '../cv-map/cv-map.component';
import { ProfileNoLocationStore } from '../state/profile-no-location.store';
import { ProfileStore } from '../state/profile.store';
import { Observable } from 'rxjs/Observable';

enum PageType {None, Next, Prev}

@Component({
  selector: 'app-slider-map-cv',
  templateUrl: './slider-map-cv.component.html',
  styleUrls: ['./slider-map-cv.component.css']
})
export class SliderMapCvComponent implements OnInit, OnDestroy {


  public profileList:any;
  currentIndex:number = 0;
  maxIndex:number;
  userId:string;
  profile:Profile;
  sub: any;
  type: PageType = PageType.None;
  loading: Observable<boolean>;
  size: Observable<number>;
  sizeNo: Observable<number>;
  filters: any;
  filter: any;


  constructor(public dialogRef: MdDialogRef<SliderMapCvComponent>,
              public profileStoreNo: ProfileNoLocationStore,
              public profileStore: ProfileStore,
              @Inject(MD_DIALOG_DATA) public data: any) {
    this.size = this.profileStoreNo.profiles.map((profiles: Profile[]) => profiles.length);
    this.sizeNo = this.profileStore.profiles.map((profiles: Profile[]) => profiles.length);
  }

  ngOnInit() {

    if (this.data.map){

      this.sub = this.profileStore.profiles.subscribe(pro => {
        this.profileList = pro;
        this.maxIndex = pro.length;

        if(this.type === PageType.None) {
          this.currentIndex = this.data.selected;
        } else if(this.type === PageType.Next) {
          this.currentIndex = 0;
        } else if(this.type === PageType.Prev) {
          this.currentIndex = this.maxIndex - 1;
        }
        this.userId = this.profileList[this.currentIndex].id;

      });
    }else{
      if (this.data.reco){
 
        this.profileList = this.data.filter;
        this.maxIndex = 5; //this.data.length;

        if(this.type === PageType.None) {
          this.currentIndex = this.data.selected;
        } else if(this.type === PageType.Next) {
          this.currentIndex = 0;
        } else if(this.type === PageType.Prev) {
          this.currentIndex = this.maxIndex - 1;
        }
        this.userId = this.profileList[this.currentIndex].id;


      }else{
        this.sub = this.profileStoreNo.profiles.subscribe(pro => {
          this.profileList = pro;
          this.maxIndex = pro.length;
          
          if(this.type === PageType.None) {
            this.currentIndex = this.data.selected;
          } else if(this.type === PageType.Next) {
            this.currentIndex = 0;
          } else if(this.type === PageType.Prev) {
            this.currentIndex = this.maxIndex - 1;
          }
          this.userId = this.profileList[this.currentIndex].id;
  
        });
        
      }
    }
  }

  ngOnDestroy() {
    if (this.data.reco=false){this.sub.unsubscribe();}  
  }

  nextCV() {
    this.currentIndex++;
    if(this.currentIndex >= this.maxIndex) {
      this.currentIndex = 0;
      this.type = PageType.Next;
      if(this.data.map){
        //this.currentIndex = this.profileStore.getTotal;
        this.profileStore.nextPage(this.data.requirement);
      }else{
        this.profileStoreNo.nextPage(this.data.requirement);
      }
      this.userId = this.profileList[this.currentIndex].id;
    } else {
      this.userId = this.profileList[this.currentIndex].id;
    }
  }

  prevCV() {
    this.currentIndex--;
    if(this.currentIndex < 0) {
      this.currentIndex = this.maxIndex-1;
      this.type = PageType.Prev;
      if(this.data.map){
        this.profileStore.prevPage(this.data.requirement);
      }else{
        this.profileStoreNo.prevPage(this.data.requirement);
      }
      this.userId = this.profileList[this.currentIndex].id;
    } else {
      this.userId = this.profileList[this.currentIndex].id;
    }
  }

  onStatusChanged(event:Status) {
    this.profileList[this.currentIndex].status = event;
  }

  onFavoriteChanged(event:boolean) {
    this.profileList[this.currentIndex].favorite = event;
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/slider-map-cv/slider-map-cv.component.ts